import styled from "styled-components";
import { theme } from "../../theme";

export const StyledProfileHeader = styled.div`
  padding-bottom: 3rem;
  h1 {
    font-size: 34px;
    font-weight: 700;
    margin: 0;
    text-transform: capitalize;
  }
  p {
    margin: 0;
    color: ${theme.textColor.quaternaryGray};
  }
`;

export const StyledProfileContainer = styled.div`
  padding: 3rem 4rem;

  @media (max-width: 786px) {
    padding: 1rem;
  }
`;

export const StyledTabs = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 48px;
  padding: 16px 0;
  border-bottom: 2px solid ${theme.textColor.primaryGray};
  @media (max-width: 786px) {
    gap: 24px;
  }
`;

export const StyledTab = styled.button<{ active?: boolean }>`
  background: transparent;
  border: none;
  font-weight: 700;
  font-size: 18px;
  cursor: pointer;
  color: ${({ active }) =>
    active ? theme.textColor.primaryBlack : theme.textColor.quaternaryGray};
  &:hover {
    color: ${({ active }) =>
      active ? theme.textColor.primaryBlack : theme.textColor.darkGray};
  }
  @media (max-width: 786px) {
    font-size: 14px;
  }
`;

export const StyledAccountInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 34px;
  padding: 1rem 0;
  div:first-child {
    p {
      font-weight: bold;
    }
    p.mobile-val {
      display: none;
    }
  }
  p {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin: 24px 0;
    a {
      margin-left: 10px;
      color: ${theme.textColor.primaryBlack};
      font-weight: 600;
    }
  }
  @media (max-width: 786px) {
    flex-direction: column;
    div:first-child {
      p.mobile-val {
        display: block;
        font-weight: unset;
        margin-top: 5px;
      }
      p {
        margin-bottom: 5px;
      }
      p:first-child {
        margin-top: 0;
      }
    }
    div {
      p.desktop-val {
        display: none;
      }
    }
    p {
      font-size: 14px;
    }
  }
`;

export const StyledBillingInfo = styled.div`
  padding: 40px 0;
  overflow-x: auto;

  @media (max-width: 786px) {
    padding: 1rem 0;
  }
`;
